// src/components/CopyButton.js
import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useSnackbar } from '../../../context/SnackbarContext';

export default function CopyButton({ text }) {
  const { showSnackbar } = useSnackbar();

  const handleCopy = async () => {
    if (text) {
      try {
        await navigator.clipboard.writeText(text);
        showSnackbar("Copied to clipboard!", "success");
      } catch (err) {
        showSnackbar("Failed to copy", "error");
      }
    }
  };

  return (
    <Tooltip title="Copy to clipboard">
      <IconButton size="small" onClick={handleCopy}>
        <ContentCopyIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}